import React, { useState, useEffect } from 'react';

const UserDetailsModal = ({ usuario_ffm, isOpen, onClose, API_URL }) => {
  const [userDetails, setUserDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState('overview');
  const [message, setMessage] = useState({ show: false, text: '', type: '' });

  useEffect(() => {
    if (isOpen && usuario_ffm) {
      fetchUserDetails();
    }
  }, [isOpen, usuario_ffm]);

  const fetchUserDetails = async () => {
    setLoading(true);
    setError(null);
    try {
      const token = localStorage.getItem('auth_token');
      const response = await fetch(`${API_URL}/admin/user-details/${usuario_ffm}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await response.json();
      if (response.ok) {
        setUserDetails(data);
      } else {
        setError(data.detail || 'Error al cargar detalles');
      }
    } catch (err) {
      setError('Error de conexión');
    } finally {
      setLoading(false);
    }
  };

  const showMessage = (text, type = 'success') => {
    setMessage({ show: true, text, type });
    setTimeout(() => setMessage({ show: false, text: '', type: '' }), 3000);
  };

  if (!isOpen) return null;

  const tiposIconos = {
    desfase_temporal: '⏰',
    falta_visitantes: '👥',
    ruta_incompleta: '🗺️',
    tiempos_inconsistentes: '⚠️',
    geoloc_fuera_zona: '📍',
    otros: '❓'
  };

  const statusColores = {
    activa: '#EF4444',
    resuelta: '#22C55E',
    apelada: '#F59E0B',
    cancelada: '#6B7280'
  };

  const statusTexto = {
    activa: 'Activa',
    resuelta: 'Resuelta',
    apelada: 'Apelada',
    cancelada: 'Cancelada'
  };

  const formatearFecha = (dateStr) => {
    if (!dateStr) return '-';
    const date = new Date(dateStr);
    return date.toLocaleDateString('es-MX', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.7)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      padding: '20px'
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        maxWidth: '1000px',
        width: '100%',
        maxHeight: '90vh',
        overflowY: 'auto',
        boxShadow: '0 20px 25px -5px rgba(0,0,0,0.3)'
      }}>
        {/* ENCABEZADO */}
        <div style={{
          padding: '24px',
          borderBottom: '1px solid #E5E7EB',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          backgroundColor: '#1E293B',
          color: 'white',
          borderTopLeftRadius: '12px',
          borderTopRightRadius: '12px'
        }}>
          <div>
            <h2 style={{ margin: 0, fontSize: '20px', fontWeight: 'bold' }}>
              {loading ? '⏳ Cargando detalles...' : `👤 ${usuario_ffm}`}
            </h2>
            {userDetails && (
              <p style={{ margin: '8px 0 0 0', fontSize: '14px', color: '#CBD5E1' }}>
                {userDetails.full_name} • {userDetails.role}
              </p>
            )}
          </div>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '24px',
              cursor: 'pointer',
              color: 'white'
            }}
          >
            ✕
          </button>
        </div>

        {/* MENSAJE */}
        {message.show && (
          <div style={{
            padding: '12px 24px',
            backgroundColor: message.type === 'success' ? '#DBEAFE' : '#FEE2E2',
            color: message.type === 'success' ? '#1E40AF' : '#991B1B',
            fontSize: '14px',
            borderBottom: '1px solid #E5E7EB'
          }}>
            {message.text}
          </div>
        )}

        {/* ERROR */}
        {error && (
          <div style={{
            padding: '24px',
            textAlign: 'center',
            color: '#DC2626',
            fontSize: '16px'
          }}>
            ❌ {error}
          </div>
        )}

        {/* CONTENIDO */}
        {!loading && userDetails && (
          <>
            {/* TABS */}
            <div style={{
              display: 'flex',
              borderBottom: '1px solid #E5E7EB',
              backgroundColor: '#F8FAFC'
            }}>
              {[
                { id: 'overview', label: '📋 Resumen', icon: '📋' },
                { id: 'penalties', label: '🚨 Penalizaciones', icon: '🚨', badge: userDetails.total_penalizaciones_activas },
                { id: 'reports', label: '⚠️ Reportes Sospechosos', icon: '⚠️', badge: userDetails.reportes_sospechosos.length }
              ].map(tab => (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  style={{
                    flex: 1,
                    padding: '12px 16px',
                    border: 'none',
                    backgroundColor: activeTab === tab.id ? 'white' : 'transparent',
                    borderBottom: activeTab === tab.id ? '3px solid #3B82F6' : 'none',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: activeTab === tab.id ? 'bold' : 'normal',
                    color: activeTab === tab.id ? '#1E293B' : '#64748B',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px'
                  }}
                >
                  {tab.label}
                  {tab.badge > 0 && (
                    <span style={{
                      backgroundColor: tab.id === 'penalties' ? '#EF4444' : '#F59E0B',
                      color: 'white',
                      borderRadius: '50%',
                      width: '24px',
                      height: '24px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '12px',
                      fontWeight: 'bold'
                    }}>
                      {tab.badge}
                    </span>
                  )}
                </button>
              ))}
            </div>

            {/* CONTENIDO DE TABS */}
            <div style={{ padding: '24px' }}>
              {/* TAB: RESUMEN */}
              {activeTab === 'overview' && (
                <div>
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                    gap: '16px',
                    marginBottom: '24px'
                  }}>
                    <div style={{
                      padding: '16px',
                      backgroundColor: '#F1F5F9',
                      borderRadius: '8px',
                      borderLeft: '4px solid #3B82F6'
                    }}>
                      <p style={{ margin: '0 0 8px 0', fontSize: '12px', color: '#64748B', textTransform: 'uppercase', fontWeight: 'bold' }}>Email</p>
                      <p style={{ margin: 0, fontSize: '14px', color: '#1E293B' }}>{userDetails.email}</p>
                    </div>

                    <div style={{
                      padding: '16px',
                      backgroundColor: '#F1F5F9',
                      borderRadius: '8px',
                      borderLeft: '4px solid #10B981'
                    }}>
                      <p style={{ margin: '0 0 8px 0', fontSize: '12px', color: '#64748B', textTransform: 'uppercase', fontWeight: 'bold' }}>Región</p>
                      <p style={{ margin: 0, fontSize: '14px', color: '#1E293B' }}>{userDetails.region}</p>
                    </div>

                    <div style={{
                      padding: '16px',
                      backgroundColor: '#F1F5F9',
                      borderRadius: '8px',
                      borderLeft: '4px solid #F59E0B'
                    }}>
                      <p style={{ margin: '0 0 8px 0', fontSize: '12px', color: '#64748B', textTransform: 'uppercase', fontWeight: 'bold' }}>Distrito</p>
                      <p style={{ margin: 0, fontSize: '14px', color: '#1E293B' }}>{userDetails.distrito}</p>
                    </div>

                    <div style={{
                      padding: '16px',
                      backgroundColor: '#F1F5F9',
                      borderRadius: '8px',
                      borderLeft: '4px solid #EF4444'
                    }}>
                      <p style={{ margin: '0 0 8px 0', fontSize: '12px', color: '#64748B', textTransform: 'uppercase', fontWeight: 'bold' }}>Penalizaciones Activas</p>
                      <p style={{ margin: 0, fontSize: '18px', color: '#EF4444', fontWeight: 'bold' }}>{userDetails.total_penalizaciones_activas}</p>
                    </div>

                    <div style={{
                      padding: '16px',
                      backgroundColor: '#F1F5F9',
                      borderRadius: '8px',
                      borderLeft: '4px solid #F59E0B'
                    }}>
                      <p style={{ margin: '0 0 8px 0', fontSize: '12px', color: '#64748B', textTransform: 'uppercase', fontWeight: 'bold' }}>Reportes Sospechosos</p>
                      <p style={{ margin: 0, fontSize: '18px', color: '#F59E0B', fontWeight: 'bold' }}>{userDetails.reportes_sospechosos.length}</p>
                    </div>

                    <div style={{
                      padding: '16px',
                      backgroundColor: '#F1F5F9',
                      borderRadius: '8px',
                      borderLeft: '4px solid #8B5CF6'
                    }}>
                      <p style={{ margin: '0 0 8px 0', fontSize: '12px', color: '#64748B', textTransform: 'uppercase', fontWeight: 'bold' }}>Última Alerta</p>
                      <p style={{ margin: 0, fontSize: '12px', color: '#1E293B' }}>{userDetails.ultimo_desfase_temporal ? formatearFecha(userDetails.ultimo_desfase_temporal) : 'Ninguna'}</p>
                    </div>
                  </div>

                  {/* Alerta si hay desfase temporal reciente */}
                  {userDetails.reportes_sospechosos.length > 0 && (
                    <div style={{
                      padding: '16px',
                      backgroundColor: '#FEE2E2',
                      borderLeft: '4px solid #DC2626',
                      borderRadius: '8px',
                      marginBottom: '24px'
                    }}>
                      <p style={{ margin: '0 0 12px 0', fontSize: '14px', fontWeight: 'bold', color: '#991B1B' }}>
                        🚨 TIEMPO SOSPECHOSO - AUDITORÍA REQUERIDA
                      </p>
                      <p style={{ margin: 0, fontSize: '12px', color: '#7F1D1D' }}>
                        Este técnico tiene {userDetails.reportes_sospechosos.length} reporte(s) con desfase temporal en los últimos 30 días. Revisa la pestaña de reportes para más detalles.
                      </p>
                    </div>
                  )}
                </div>
              )}

              {/* TAB: PENALIZACIONES */}
              {activeTab === 'penalties' && (
                <div>
                  {userDetails.penalizaciones_activas.length === 0 ? (
                    <div style={{
                      textAlign: 'center',
                      padding: '40px',
                      color: '#64748B'
                    }}>
                      <p style={{ fontSize: '48px', margin: '0 0 12px 0' }}>✅</p>
                      <p>No hay penalizaciones activas</p>
                    </div>
                  ) : (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                      {userDetails.penalizaciones_activas.map(penalty => (
                        <div key={penalty.id} style={{
                          padding: '16px',
                          border: '1px solid #E5E7EB',
                          borderLeft: `4px solid ${statusColores[penalty.status]}`,
                          borderRadius: '8px',
                          backgroundColor: '#F8FAFC'
                        }}>
                          <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'flex-start',
                            marginBottom: '12px'
                          }}>
                            <div>
                              <p style={{ margin: '0 0 4px 0', fontSize: '14px', fontWeight: 'bold', color: '#1E293B' }}>
                                {tiposIconos[penalty.tipo_penalidad]} {penalty.tipo_penalidad.replace(/_/g, ' ').toUpperCase()}
                              </p>
                              <p style={{ margin: 0, fontSize: '12px', color: '#64748B' }}>
                                {penalty.motivo}
                              </p>
                            </div>
                            <span style={{
                              backgroundColor: statusColores[penalty.status],
                              color: 'white',
                              padding: '4px 12px',
                              borderRadius: '16px',
                              fontSize: '12px',
                              fontWeight: 'bold',
                              whiteSpace: 'nowrap'
                            }}>
                              {statusTexto[penalty.status]}
                            </span>
                          </div>

                          {penalty.descripcion && (
                            <p style={{ margin: '12px 0 0 0', fontSize: '12px', color: '#475569', fontStyle: 'italic' }}>
                              "{penalty.descripcion}"
                            </p>
                          )}

                          {penalty.reportes_asociados && penalty.reportes_asociados.length > 0 && (
                            <div style={{ marginTop: '12px', paddingTop: '12px', borderTop: '1px solid #E5E7EB' }}>
                              <p style={{ margin: '0 0 8px 0', fontSize: '12px', fontWeight: 'bold', color: '#64748B' }}>
                                📎 Reportes Asociados:
                              </p>
                              <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                                {penalty.reportes_asociados.map(id => (
                                  <span key={id} style={{
                                    backgroundColor: '#E0F2FE',
                                    color: '#0369A1',
                                    padding: '4px 8px',
                                    borderRadius: '4px',
                                    fontSize: '11px',
                                    fontFamily: 'monospace'
                                  }}>
                                    #{id}
                                  </span>
                                ))}
                              </div>
                            </div>
                          )}

                          {penalty.notas_auditor && (
                            <div style={{ marginTop: '12px', paddingTop: '12px', borderTop: '1px solid #E5E7EB' }}>
                              <p style={{ margin: '0 0 4px 0', fontSize: '11px', fontWeight: 'bold', color: '#64748B' }}>
                                📝 Notas del Auditor:
                              </p>
                              <p style={{ margin: 0, fontSize: '12px', color: '#475569', fontStyle: 'italic' }}>
                                "{penalty.notas_auditor}"
                              </p>
                            </div>
                          )}

                          <div style={{
                            marginTop: '12px',
                            paddingTop: '12px',
                            borderTop: '1px solid #E5E7EB',
                            display: 'flex',
                            justifyContent: 'space-between',
                            fontSize: '11px',
                            color: '#64748B'
                          }}>
                            <span>📅 Aplicada: {formatearFecha(penalty.fecha_aplicacion)}</span>
                            {penalty.fecha_resolucion && <span>✅ Resuelta: {formatearFecha(penalty.fecha_resolucion)}</span>}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}

              {/* TAB: REPORTES SOSPECHOSOS */}
              {activeTab === 'reports' && (
                <div>
                  {userDetails.reportes_sospechosos.length === 0 ? (
                    <div style={{
                      textAlign: 'center',
                      padding: '40px',
                      color: '#64748B'
                    }}>
                      <p style={{ fontSize: '48px', margin: '0 0 12px 0' }}>✅</p>
                      <p>No hay reportes sospechosos en los últimos 30 días</p>
                    </div>
                  ) : (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                      {userDetails.reportes_sospechosos.map(report => (
                        <div key={report.id} style={{
                          padding: '16px',
                          border: '1px solid #FEE2E2',
                          borderLeft: '4px solid #DC2626',
                          borderRadius: '8px',
                          backgroundColor: '#FFFBFB'
                        }}>
                          <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'flex-start',
                            marginBottom: '12px'
                          }}>
                            <div>
                              <p style={{ margin: '0 0 4px 0', fontSize: '14px', fontWeight: 'bold', color: '#991B1B' }}>
                                🚨 Reporte #{report.id} - Desfase Temporal
                              </p>
                              <p style={{ margin: 0, fontSize: '12px', color: '#64748B' }}>
                                {formatearFecha(report.fecha)}
                              </p>
                            </div>
                          </div>

                          {report.razon_desfase_temporal && (
                            <p style={{ margin: '8px 0', fontSize: '12px', color: '#475569' }}>
                              <strong>Razón:</strong> {report.razon_desfase_temporal}
                            </p>
                          )}

                          <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
                            gap: '12px',
                            marginTop: '12px'
                          }}>
                            <div style={{
                              padding: '12px',
                              backgroundColor: '#FEF3C7',
                              borderRadius: '6px',
                              fontSize: '12px'
                            }}>
                              <p style={{ margin: '0 0 4px 0', fontWeight: 'bold', color: '#92400E' }}>Segmentos Desfasados</p>
                              <p style={{ margin: 0, fontSize: '16px', fontWeight: 'bold', color: '#D97706' }}>{report.segmentos_desfasados}</p>
                            </div>

                            <div style={{
                              padding: '12px',
                              backgroundColor: '#DBEAFE',
                              borderRadius: '6px',
                              fontSize: '12px'
                            }}>
                              <p style={{ margin: '0 0 4px 0', fontWeight: 'bold', color: '#082F49' }}>Diferencia Promedio</p>
                              <p style={{ margin: 0, fontSize: '16px', fontWeight: 'bold', color: '#0284C7' }}>
                                {report.diferencia_promedio_minutos ? `${Math.round(report.diferencia_promedio_minutos)} min` : '-'}
                              </p>
                            </div>

                            <div style={{
                              padding: '12px',
                              backgroundColor: '#E0E7FF',
                              borderRadius: '6px',
                              fontSize: '12px'
                            }}>
                              <p style={{ margin: '0 0 4px 0', fontWeight: 'bold', color: '#3730A3' }}>Servicios Realizados</p>
                              <p style={{ margin: 0, fontSize: '16px', fontWeight: 'bold', color: '#6366F1' }}>{report.total_segment_reports}</p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default UserDetailsModal;
